import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { ApiMetaDataDTO } from 'declarations'
import { toast } from 'react-toastify'

import { client } from 'services/helpers/apiConfig'

type SearchPartNumberRulesQueryParamsDTO = {
  term: string
  partNumberClassIds: string
}

type SearchResultDTO = {
  search: {
    more_than_100: boolean
    record_count: number
    term_count: number
    terms: string[]
  }
}
type ApiResponseDTO = {
  code: number
  data: SearchResultDTO
  api_metadata: ApiMetaDataDTO
}

const useSprSearchQuery = (
  params: SearchPartNumberRulesQueryParamsDTO
): UseQueryResult<SearchResultDTO> => {
  return useQuery({
    queryKey: ['spr', 'search', params.term, params.partNumberClassIds],
    queryFn: async () => {
      try {
        const reqParams = {
          term: params.term,
          part_number_class_id: params.partNumberClassIds,
        }

        const res = await client.get<ApiResponseDTO>(
          `/supplier_preference_rules/search`,
          {
            params: reqParams,
          }
        )

        return res.data.data
      } catch (err) {
        toast.error(err.response.data.message)
        throw err.response.data
      }
    },
    enabled: params.term !== '',
  })
}

export { useSprSearchQuery }
